__webpack_require__.p = "/reports-dashboard-templates-sidebar-items/referrals-hub/";